import Link from 'next/link';

import { IconButton, useSlotRecipe } from '@chakra-ui/react';

import { PaginationArrowProps } from './pagination-arrow.props';

export const PaginationArrow = ({
    isDisabled,
    ariaLabel,
    icon,
    pageUrl,
    onPageChange,
    testId,
}: PaginationArrowProps) => {
    const recipe = useSlotRecipe({ key: 'pagination' });
    const styles = recipe({});

    const commonProps = {
        'aria-label': ariaLabel,
        variant: 'ghost' as const,
        size: 'md' as const,
        css: styles.arrow,
        'data-testid': testId,
    };

    if (isDisabled) {
        return (
            <IconButton {...commonProps} disabled>
                {icon}
            </IconButton>
        );
    }

    return (
        <IconButton {...commonProps} asChild>
            <Link href={pageUrl} prefetch={false} onClick={onPageChange}>
                {icon}
            </Link>
        </IconButton>
    );
};
